
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class RiskAcceptanceCriteriaService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    // saveRiskAcceptanceCriteria(body) {
    //     return this.http.post(`credit/risk-acceptance-criteria`, JSON.stringify(body))
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    // updateRiskAcceptanceCriteria(body, id) {
    //     return this.http.put(`credit/risk-acceptance-criteria/${id}`, JSON.stringify(body))
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    // deleteRiskAcceptanceCriteria(id) {
    //     return this.http.delete(`credit/risk-acceptance-criteria/${id}`)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    getRiskAcceptanceCriteria(model) {
        return this.http.post(`rac/risk-acceptance-criteria-input`, model).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getSavedRiskAcceptanceCriteria(model) {
        return this.http.post(`rac/saved-rac-for-a-loan`, model).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getRiskAcceptanceCriteriaUpdate(productId,targetId) {
        return this.http.get(`rac/risk-acceptance-criteria/product/${productId}/target/${targetId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}